import { IsNotEmpty } from 'class-validator';

import { GetHashesHashDto } from './get-hashes-hash.dto';

export class GetHashesDto {
  @IsNotEmpty()
  hashes: GetHashesHashDto[];
}
